import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { seApi } from "./features/api/apiSlice";
import apiKeyReducer from "./features/api/apiKeySlice";
import journeyReducer from "./features/journey/journeySlice";
import filtersReducer from "./features/filters/filtersSlice";

export const store = configureStore({
    reducer: {
        apiKey: apiKeyReducer,
        journey: journeyReducer,
        filters: filtersReducer,
        [seApi.reducerPath]: seApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(seApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
